/* eslint-disable max-len */
import React, { FC } from 'react'
import styled from 'styled-components'

const StyledIcon = styled.svg`
	width: 24px;
	height: 24px;
	fill: #21ba72;
	min-height: 24px;
	min-width: 24px;
	margin-right: 12px;
`

export const CheckIcon: FC<React.HTMLAttributes<unknown>> = () => (
	<StyledIcon viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.04905 11.5764C6.59494 11.1331 5.84363 11.1153 5.36812 11.5397C4.8938 11.963 4.87478 12.6663 5.32889 13.1108L8.89481 16.6556C9.1183 16.8745 9.42738 16.9989 9.75073 17H9.75548C10.0776 17 10.3855 16.8778 10.609 16.6611L18.6654 8.8838C19.1218 8.44272 19.11 7.73943 18.638 7.31278C18.1649 6.88503 17.4124 6.89836 16.9571 7.33834L9.76143 14.2857L7.04905 11.5764Z"
		/>
	</StyledIcon>
)
